"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _box = require("@oneloop/box");
var _excluded = ["variant"]; //* eslint-disable indent */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var size = function size(type) {
  switch (type) {
    case 'medium':
      return '24px';
    default:
      return '16px';
  }
};
var sizeSpinner = function sizeSpinner(type) {
  switch (type) {
    case 'medium':
      return '2em';
    default:
      return '1em';
  }
};
var bounce = (0, _styledComponents.keyframes)(["0%{top:30px;height:5px;border-radius:60px 60px 20px 20px;transform:scaleX(2);}35%{height:24px;border-radius:50%;transform:scaleX(1);}100%{top:0;}"]);
var LoaderStyled = (0, _styledComponents["default"])(_box.Box).withConfig({
  componentId: "sc-fk6ta3-0"
})(["position:relative;height:37px;width:", ";::before{position:absolute;content:'';display:block;top:0;width:", ";height:", ";border-radius:50%;transform-origin:50%;animation:", " 500ms alternate infinite ease;", "}"], function (props) {
  return size(props.size);
}, function (props) {
  return size(props.size);
}, function (props) {
  return size(props.size);
}, bounce, (0, _styledSystem.variant)({
  prop: 'kind',
  scale: 'loader'
}));
var Loader = exports.Loader = function Loader(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bounce' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    tx: "loaders",
    variant: variant
  }, variant === 'spinner' && /*#__PURE__*/_react["default"].createElement(StyledCircle, _extends({}, props, {
    __css: {
      mr: '10px'
    }
  })), variant === 'bounce' && /*#__PURE__*/_react["default"].createElement(LoaderStyled, _extends({}, props, {
    __css: {
      mr: '10px'
    }
  })));
};
Loader.propTypes = {
  size: _propTypes["default"].string,
  kind: _propTypes["default"].string
};
Loader.defaultProps = {
  size: 'small',
  kind: 'primary'
};
var circle = (0, _styledComponents.keyframes)(["0%{transform:rotate(360deg);}100%{transform:rotate(0deg);}"]);
var StyledCircle = (0, _styledComponents["default"])(_box.Box).withConfig({
  componentId: "sc-fk6ta3-1"
})(["width:", ";height:", ";padding:8px;border-radius:50%;background-image:conic-gradient(#272E33,#FFFFFF);animation:", " 1s ease 0s infinite;clip-path:circle(80px at center);-webkit-mask-image:radial-gradient(circle at center,transparent 54%,black 54.8%);mask-image:radial-gradient(circle at center,transparent 54%,black 54.8%);"], function (props) {
  return sizeSpinner(props.size);
}, function (props) {
  return sizeSpinner(props.size);
}, circle);